import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function NcertBookPhysTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="ncertbook" />

    </>
  );
}

export default NcertBookPhysTopics;